import React, { useState } from 'react'
import Images from '../../../../resources/images/Images';
import classes from "../CustomInputs.module.css";
import Strings from '../../../../resources/Strings';
import RoundButton from '../../Buttons/RoundButton/RoundButton';
import { INPUTS_PROPS } from '../../../../enums/Enums';
// import { ListItem } from '../../../../entities/UIEntities/ListItem';
// import SelectInput from './SelectInput';

const ChargingPositionInput = (props) => {
  const [chargingPort, setChargingPort] = useState(props.chargingPosition ? props.chargingPosition : 0);

  const chargingPortsPositions = [
    { position: 'absolute', top: props.isShowVehicleField ? '880px' : '810px', left: props.isShowVehicleField ? '130px' : '130px'},
    { position: 'absolute', top: props.isShowVehicleField ? '865px' : '795px', left: props.isShowVehicleField ? '95px' : '95px'},
    { position: 'absolute', top: props.isShowVehicleField ? '830px' : '760px', left: props.isShowVehicleField ? '85px' : '85px'},
    { position: 'absolute', top: props.isShowVehicleField ? '795px' : '725px', left: props.isShowVehicleField ? '95px' : '95px'},
    { position: 'absolute', top: props.isShowVehicleField ? '790px' : '720px', left: props.isShowVehicleField ? '130px' : '130px'},
    { position: 'absolute', top: props.isShowVehicleField ? '790px' : '720px', left: props.isShowVehicleField ? '340px' : '340px'},
    { position: 'absolute', top: props.isShowVehicleField ? '795px' : '730px', left: props.isShowVehicleField ? '380px' : '380px'},
    { position: 'absolute', top: props.isShowVehicleField ? '830px' : '765px', left: props.isShowVehicleField ? '390px' : '390px'},
    { position: 'absolute', top: props.isShowVehicleField ? '865px' : '800px', left: props.isShowVehicleField ? '380px' : '380px'},
    { position: 'absolute', top: props.isShowVehicleField ? '880px' : '810px', left: props.isShowVehicleField ? '340px' : '340px'},
  ];

  return (
    <>
        <div className={classes.chargingPositionContainer}>
            <p>{Strings.CHARGING_POSITION}</p>
            
            <div className={classes.chargingPositionImageContainer}>
                <img className={classes.image} src={Images.CAR_WITHOUT_CHARGING_PORTS} />
            </div>

            {chargingPortsPositions.map((cp, index) => {
              let chargingPortDisplayIndex = index + 1;

              return (
                <div key={index} style={{position: cp.position, top: cp.top, left: cp.left}}>
                  <RoundButton
                    isSelected={chargingPort === chargingPortDisplayIndex}
                    onClick={() => {
                      setChargingPort(chargingPortDisplayIndex);
                      props.handleChange(props?.index, {[INPUTS_PROPS.CHARGING_POSITION] : chargingPortDisplayIndex});
                    }}
                  >
                    {chargingPortDisplayIndex}
                  </RoundButton>
                </div>
              );
            })}

            {chargingPort !== 0 && (
              <div className={classes.chargingPositionSelection}>
                {`${Strings.CHARGING_PORT_SELECTED}: ${chargingPort}`}
              </div>
            )}

            {/* <SelectInput 
              label={Strings.INPUT_LABELS.CHARGING_POSITION}
              id={INPUTS_PROPS.CHARGING_POSITION}
              onChange={(event) => props?.handleChange(props?.index, event)}
              value={props?.chargingPosition ? props?.chargingPosition : ""}
              list={Array.from(Array(Object.keys(CHARGING_POSITIONS).length).keys()).map(
                (value) => new ListItem(value, value + 1, value + 1)
              )}
              isStepSubmitted={props.isStepSubmitted}
              handleError={props.handleError}
              hasError={props.hasError}
              errorMessage={props.errorMessage}
            /> */}
        </div>
    </>
  )
}

export default ChargingPositionInput;